"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncementService = void 0;
const AnnouncementServiceStub_1 = require("./AnnouncementServiceStub");
const AnnouncementServiceLive_1 = require("./AnnouncementServiceLive");
class AnnouncementService {
    static create(stub) {
        if (stub) {
            return new AnnouncementServiceStub_1.AnnouncementServiceStub();
        }
        return new AnnouncementServiceLive_1.AnnouncementServiceLive();
    }
}
exports.AnnouncementService = AnnouncementService;
//# sourceMappingURL=AnnouncementService.js.map